import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import MFELoader from 'routes/components/MFELoader';
import { MFE_WC_EXPORTS } from 'shared/constants';
import { useGetAuthData } from 'shared/hooks';
import useEventListener from 'shared/hooks/useEventListener';
import { Center } from 'shared/styles';
import {
  BreadcrumpDataType,
  GoToRouteType,
  HostConfigType,
} from 'shared/types';
import { useQueryParams } from 'shared/utils';
import { useAccessControl } from 'utils/access-control';
import config from 'utils/config';

type HostPropType = {
  setConfirmationData: any;
  goToRoute: GoToRouteType;
  hostConfig: HostConfigType;
  setBreadcrumpData?: (
    str: BreadcrumpDataType | React.SetStateAction<BreadcrumpDataType>,
  ) => void;
};

const SurveyTemplate = (hostProps: HostPropType) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { role } = useAccessControl();
  const product = 'freshsurvey';
  const hostParams = useParams<Record<string, string>>();
  const queryParams = useQueryParams();

  const {
    data: surveyServAuthInfo,
    isLoading,
    isError,
    refetch,
  } = useGetAuthData();

  const refreshTokenHandler = () => {
    refetch();
  };

  const routeHandler = (data: any) => {
    if (data.detail.path) history.push(data.detail.path);
  };

  const UpdateBreadcrumb = (data: any) => {
    if (hostProps?.setBreadcrumpData)
      if (typeof data.detail === 'function') {
        hostProps.setBreadcrumpData((old: BreadcrumpDataType) =>
          data.detail(old),
        );
      } else {
        hostProps.setBreadcrumpData(data.detail);
      }
  };

  useEventListener('survey_mfe:route', routeHandler);
  useEventListener('survey_mfe:breadcrumb', UpdateBreadcrumb);
  useEventListener('survey_mfe:refresh_token', refreshTokenHandler);

  if (isLoading) {
    return <MFELoader />;
  }

  if (isError) return <Center>{t('empty_state.message.network_error')}</Center>;

  return (
    <Suspense fallback={<MFELoader />}>
      <survey-components
        url={config.SURVEY_MICROFRONTEND_REMOTE}
        module-name={MFE_WC_EXPORTS.name}
        export-name={MFE_WC_EXPORTS.modules.SurveyTemplateWC}
        fn="default"
        key={hostParams?.id || 'create'}
        data={JSON.stringify({
          ...hostProps,
          role,
          product,
          surveyServAuthInfo,
          hostParams: {
            ...hostParams,
            isImport: Boolean(queryParams.get('import') || false),
          },
        })}
      >
        <div slot="loading">
          <MFELoader wcLoading />
        </div>
        <p slot="failure">{t('loading_failed')}</p>
      </survey-components>
    </Suspense>
  );
};

export default SurveyTemplate;
